export const errorsList = {
  tiktok_oauth_failed: 'Authorization failed. Please try again',
  name_not_available: 'Authorization failed. Please try again',
  country_unavailable: 'Service is currently unavailable in your country',
  internal_server_error: 'Internal server error',
  ip_blocked_by_admins: 'Your IP address has been blocked for security reasons',
  default_error:
    'Registration is currently unavailable. Please contact support team',
}
